<template>
  <div
    class="rr-field"
    :class="classes"
  >
    <div
      class="rr-field__label"
      :class="labelClasses"
      v-if="$slots.afterLabel || label"
    >
      <label
        v-if="label"
        class="rr-label"
        :for="labelFor"
        v-html="label"
      >
      </label>
      <slot name="afterLabel"></slot>
    </div>
    <div class="rr-field__input">
      <slot></slot>
      <div class="rr-field__msg" v-if="$slots.msg">
        <slot name="msg"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Field',
  props: {
    /**
     *  В виде строки
     */
    row: Boolean,
    /**
     *  Текст лейбла
     */
    label: String,
    /**
     *  HTML-атрибут for для лейбла
     */
    labelFor: String,
    /**
     *  Размер лейбла
     */
    labelSize: {
      type: String,
      validator(value) {
        return ['', 'sm'].indexOf(value) !== -1;
      },
    },
  },
  computed: {
    classes() {
      return {
        'rr-field_row': this.row,
      };
    },
    labelClasses() {
      return {
        'rr-field__label_sm': this.labelSize === 'sm',
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "./Field";
</style>
